import * as React from 'react'
import { Slot } from 'radix-ui'

import { cn } from '@/lib/utils'

export interface SourceTagProps extends React.ComponentProps<'span'> {
  /** Leading glyph, decoration (`aria-hidden`). */
  icon?: React.ReactNode
  /** Render the child (a `button`) with the tile look. */
  asChild?: boolean
}

/**
 * A lead source as a warm mono tile (Hitteschaal). The name is always text and truncates
 * with its full text on hover. Styled by `.vonk-source` in `index.css`.
 */
function SourceTag({ icon, asChild = false, className, children, title, ...props }: SourceTagProps) {
  const Comp = asChild ? Slot.Root : 'span'
  const text = title ?? (typeof children === 'string' ? children : undefined)
  return (
    <Comp data-slot="source-tag" className={cn('vonk-source', className)} title={text} {...props}>
      {icon ? (
        <span aria-hidden className="vonk-source__icon vonk-duotone">
          {icon}
        </span>
      ) : null}
      <Slot.Slottable>{children}</Slot.Slottable>
    </Comp>
  )
}

export { SourceTag }
